import { render, staticRenderFns } from "./TableColumnSetting.vue?vue&type=template&id=f146fcf6&"
import script from "./TableColumnSetting.vue?vue&type=script&lang=js&"
export * from "./TableColumnSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports